// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loader[data-v-15567d02]{width:60px;height:60px;border-radius:9999px;border-width:4px;border-style:solid;animation:rotate-data-v-15567d02 1s linear infinite;border-right-color:transparent!important}@keyframes rotate-data-v-15567d02{0%{transform:rotate(0)}to{transform:rotate(1turn)}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
